export const TARIFF_PATTERNS = {
  LOW_VOLTAGE: ['b3', 'bt', 'b1', 'b2', 'baixa'] as const,
  MEDIUM_VOLTAGE: ['a4', 'as', 'a3', 'a2', 'média'] as const,
} as const;

export const MODALITY_PATTERNS = {
  BLUE: ['blue', 'azul'] as const,
  GREEN: ['green', 'verde'] as const,
} as const;

export type VoltageType = 'LOW_VOLTAGE' | 'MEDIUM_VOLTAGE' | null;

export type ModalityType = 'BLUE' | 'GREEN' | null;

export interface IHistoryFields {
  showConsumption?: boolean;
  showPeakConsumption?: boolean;
  showOffPeakConsumption?: boolean;
  showDemand?: boolean;
  showPeakDemand?: boolean;
  showOffPeakDemand?: boolean;
}

export const HISTORY_FIELD_DEFAULTS: IHistoryFields = {
  showConsumption: false,
  showPeakConsumption: false,
  showOffPeakConsumption: false,
  showDemand: false,
  showPeakDemand: false,
  showOffPeakDemand: false,
} as const;
